import React from 'react';
import { useDispatch } from "react-redux";
import { Button, Card, Grid } from '@material-ui/core';
import { agendaSeleccionarTurno } from '../../../actions/turnos/agenda';

const style = {
    grid: {
        marginTop: 10, 
        marginRight: 10,
        fontWeight: 600,
        fontSize: 'small', 
        textAlign: 'center', 
        fontFamily: 'sans-serif',
    },
};

export const ListaDisponibles = ({virtual, presencial, itemsDisponibles, selectedDate, setSelectedDate, idProfesional}) => {
    const dispatch = useDispatch();
    const [idTipoTurnoOrig, setIdTipoTurnoOrig] = React.useState();

    const turnosNormales = itemsDisponibles.filter(s => !s.sobreTurno || s.sobreTurno === null);
    const sobreTurnos = itemsDisponibles.filter(s => s.sobreTurno);

    const handleClickDate = (item, idTipoTurno) => {
        if(item.idTipoTurno === 3){
            const newItem = {...item, idTipoTurno: idTipoTurno}
            setIdTipoTurnoOrig(idTipoTurno)
            setSelectedDate(newItem)
            dispatch( agendaSeleccionarTurno(newItem) )
        } else{
            setSelectedDate(item)
            dispatch( agendaSeleccionarTurno(item) )
        }
    }

    return ( 
        <>
            {turnosNormales.length>0&&
                <>
                    <h1>{idProfesional === null ? 'Profesional' : null}</h1>
                    {turnosNormales.map((item) => (
                        item.idTipoTurno === 3
                            ?
                                <>
                                    {presencial&&
                                        <Button 
                                            variant="contained"
                                            style={{margin: 5, backgroundColor: 'green'}}
                                            disabled={(selectedDate?.idAgenda === item.idAgenda && idTipoTurnoOrig === 1) ? true : false}
                                            onClick={() => handleClickDate(item, 1)}        //IdTipoTurno = 1      Presencial
                                        >
                                            {idProfesional === null ? item.efectorRed.nombreEfector : item.hora}
                                        </Button>
                                    }
                                    {virtual&&
                                        <Button 
                                            variant="contained"
                                            style={{margin: 5, backgroundColor: 'yellow'}}
                                            disabled={(selectedDate?.idAgenda === item.idAgenda && idTipoTurnoOrig === 2) ? true : false}
                                            onClick={() => handleClickDate(item, 2)}        //IdTipoTurno = 2      VideoConsulta
                                        >
                                            {idProfesional === null ? item.efectorRed.nombreEfector : item.hora}
                                        </Button>
                                    }
                                </>
                            :
                                <Button 
                                    variant="contained"
                                    style={{margin: 5, backgroundColor: item.idTipoTurno === 1 ? 'green' : 'yellow'}}
                                    disabled={selectedDate === item ? true : false}
                                    onClick={() => handleClickDate(item)}
                                >
                                    {idProfesional === null ? item.efectorRed.nombreEfector : item.hora}
                                </Button>
                    ))}
                    <Grid container direction="row" alignItems="center" justify='center'>
                        <Grid item xs={3} style={style.grid} >
                            <Card style={{backgroundColor: 'green'}} >Presencial</Card>
                        </Grid>
                        <Grid item xs={3} style={style.grid} >
                            <Card style={{backgroundColor: 'yellow'}} >Virtual</Card>
                        </Grid>
                    </Grid>
                </>
            }
            {sobreTurnos.length>0&&
                <>
                    {idProfesional&&
                        <>
                            <h3 style={{marginTop: 20, marginBottom: 5}}>SobreTurnos</h3>
                            {sobreTurnos.map((item) => (
                                item.idTipoTurno === 3
                                    ?
                                        <>
                                            {presencial&&
                                                <Button 
                                                    variant="contained"
                                                    style={{margin: 5, minWidth: 69, minHeight: 36, backgroundColor: 'lightblue'}}
                                                    disabled={(/* turnosNormales.length>0 || */ (selectedDate?.idAgenda === item.idAgenda && idTipoTurnoOrig === 1)) ? true : false}
                                                    onClick={() => handleClickDate(item, 1)}        //IdTipoTurno = 1      Presencial
                                                >
                                                </Button>
                                            }
                                            {virtual&&
                                                <Button 
                                                    variant="contained"
                                                    style={{margin: 5, minWidth: 69, minHeight: 36, backgroundColor: 'orange'}}
                                                    disabled={(/* turnosNormales.length>0 || */ (selectedDate?.idAgenda === item.idAgenda && idTipoTurnoOrig === 2)) ? true : false}
                                                    onClick={() => handleClickDate(item, 2)}        //IdTipoTurno = 2      VideoConsulta
                                                >
                                                </Button>
                                            }
                                        </>
                                    :
                                        <Button 
                                            variant="contained"
                                            style={{margin: 5, minWidth: 69, minHeight: 36, backgroundColor: item.idTipoTurno === 1 ? 'lightblue' : 'orange'}}
                                            disabled={(/* turnosNormales.length>0 || */ selectedDate === item) ? true : false}
                                            onClick={() => handleClickDate(item)}
                                        >
                                        </Button>
                            ))}
                            <Grid container direction="row" alignItems="center" justify='center'>
                                <Grid item xs={3} style={style.grid} >
                                    <Card style={{backgroundColor: 'lightblue'}} >Presencial</Card>
                                </Grid>
                                <Grid item xs={3} style={style.grid} >
                                    <Card style={{backgroundColor: 'orange'}} >Virtual</Card>
                                </Grid>
                            </Grid>
                        </>
                    }
                </>
            }
        </>
     );
}
 